module.exports = {
  load_error: 'Diese Seite konnte nicht geladen werden. Bitte versuche es erneut oder kontaktiere deinen Administrator.',
  retry_loading: 'Erneut versuchen',
  imprint: 'Impressum',
  request_chat_access_info: 'Sie haben am {date} den Chat mit {username} angefragt.',
  job_description_question: 'Wie lautet Deine Stellenbeschreibung?',
  about_me_question: 'Was möchtest Du, dass wir über Dich wissen?',
  request_chat_access_sent: 'Anfrage gesendet',
  invalid_user_id: 'Ungültige Benutzer-ID',
  open_chat: 'Chat öffnen',
  about_me: 'Über mich',
  expertise_question: 'In welchen Bereichen verfügst Du über besonders viel Fachwissen?',
  responsibilities: 'Dafür bin ich verantwortlich',
  responsibilities_question: 'Wofür bist Du in Deiner Position verantwortlich?',
  my_profile: 'Mein Profil',
  request_access_to_show_more: 'Zugang anfragen, um mehr Informationen zu sehen.',
  request_chat_access: 'Administrator um Chat-Freigabe mit {username} bitten',
  expertise: 'Darin kenne ich mich besonders gut aus',
}
